import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {NotesModel, AddNotesModel, ReadNotesModel} from "./notes.model";

@Injectable()
export class NotesService implements IDataModel {

    private API_ROOT:string = '/notes';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<NotesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getOne(id:number):Observable<ResponseModel<NotesModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:AddNotesModel): Observable<ResponseModel<NotesModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    readNote(fields:ReadNotesModel): Observable<boolean>  {
        return this.http.post(`${this.API_ROOT}/read`, fields).map((res) => res.json());
    }

    edit(id:number, fields:NotesModel): Observable<ResponseModel<NotesModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/notes/notes.service.ts